import { Component, Input } from '@angular/core';
import { environment } from '@env';
import { WindowService } from '@shared/services/window.service';

@Component({
  selector: 'app-manage-subscriptions',
  templateUrl: './manage-subscriptions.component.html',
  styleUrls: ['./manage-subscriptions.component.scss']
})
export class ManageSubscriptionsComponent {

  @Input() package!: string;
  @Input() endDate: Date | null = null;

  constructor(private windowService: WindowService) { }

  manageSubscriptions() {
    alert('TODO');
  }

}
